<script>
	export let link = "/";
	export let text;
	export let color = "red";
</script>

<div class="button">
	<a href={link} target="_blank">
		<div class="t-button t-button--{color}">
			{@html text}
		</div>
	</a>
</div>

<style lang="scss">
	.button {
		margin-top: 40px;
	}
	a {
		text-shadow: none;
	}
</style>
